import React, { useState } from 'react';
import { Grid2, TextField, InputAdornment, Tooltip, IconButton } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';

const FormikPasswordInput = ({ name, ...props }) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const handleToggleShowPassword = () => setShowPassword(!showPassword);

    return (
        <Grid2 size={{ xs: 12 }}>
            <Field name={name}>
                {({ field, meta }) => (
                    <TextField
                        {...field}
                        {...props}
                        error={meta.error && meta.touched}
                        helperText={meta.touched && meta.error}
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip
                                        title={
                                            showPassword
                                                ? t('formik.hidePassword')
                                                : t('formik.showPassword')
                                        }
                                    >
                                        <IconButton
                                            onClick={handleToggleShowPassword}
                                            edge="end"
                                            disableRipple
                                        >
                                            {showPassword ? (
                                                <VisibilityOffIcon />
                                            ) : (
                                                <RemoveRedEyeIcon />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                )}
            </Field>
        </Grid2>
    );
};

export default FormikPasswordInput;
